import { jsx, Fragment } from "react/jsx-runtime";
import { normalizeDynamoValue } from "./types.js";
import { ConciergePartItem } from "./ConciergePartItem.js";
function ConciergeMessagePart({
  parts,
  productMetadataMap,
  onProductClick,
  isStreaming,
  pdpStacklineSku
}) {
  if (!parts || parts.length === 0) return null;
  const normalizedParts = normalizeDynamoValue(parts);
  return /* @__PURE__ */ jsx(Fragment, { children: normalizedParts.map((part, index) => /* @__PURE__ */ jsx(
    ConciergePartItem,
    {
      part,
      allParts: normalizedParts,
      productMetadataMap,
      onProductClick,
      isStreaming,
      pdpStacklineSku
    },
    `${part.type}-${index}`
  )) });
}
export {
  ConciergeMessagePart
};
//# sourceMappingURL=index.js.map
